import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { environment } from "src/environments/environment";

export const qrCodeContentValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
    const qrCodeLinkValue = control.value;

    if (!qrCodeLinkValue) return {};

    try {
        new URL(qrCodeLinkValue);
    } catch {
        return { isNotURL: true };
    }
    
    const valueAsUrl = new URL(qrCodeLinkValue);
    if (valueAsUrl.host !== 'go.nibo.com.br') return { invalidHost: true}   

    return {};
}

export const qrCodeLinkValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
    const qrCodeLinkValue = control.value;

    if (!qrCodeLinkValue) return {};

    try {
        new URL(qrCodeLinkValue);
    } catch {
        return { isNotURL: true };
    }
    
    const valueAsUrl = new URL(qrCodeLinkValue);
    if (valueAsUrl.host !== 'brniboappwhitelabel.blob.core.windows.net') return { invalidHost: true}   

    return {};
}